import { ResponseErrorAlert } from "@nimble/react-requests/components/shared/response-error-alert";
import type React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface AuthErrorModalViewProps {
  isOpen: boolean;
  error: Error | null;
  isRetrying: boolean;
  onRetry: () => void;
  onSignOut?: () => void;
}

export default function AuthErrorModalView({
  isOpen,
  error,
  isRetrying,
  onRetry,
  onSignOut,
}: AuthErrorModalViewProps): React.JSX.Element {
  return (
    <Dialog open={isOpen}>
      <DialogContent showCloseButton={false} className="sm:max-w-md">
        <DialogHeader className="sr-only">
          <DialogTitle>Error</DialogTitle>
          <DialogDescription>
            An error occurred. Please try again.
          </DialogDescription>
        </DialogHeader>
        <ResponseErrorAlert error={error} />

        <DialogFooter className="sm:justify-center gap-2">
          {onSignOut && (
            <Button
              onClick={onSignOut}
              disabled={isRetrying}
              className="min-w-32"
              variant="outline"
            >
              Sign Out
            </Button>
          )}
          <Button
            onClick={onRetry}
            disabled={isRetrying}
            className="min-w-32"
            variant="default"
          >
            {isRetrying ? "Retrying..." : "Try Again"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
